import React, { useCallback, useState } from 'react'
import { connect } from 'react-redux'
import { loadDataForDate } from 'core/actions'
import moment from 'moment'

const DatePickerContext = React.createContext(null)

// default value also need to set in reducer
const DatePickerProvider = ({
  children,
  // setEndDateDispatch,
  // dispatch,
  //  getState,
  // setTransDate,
  // transDate,
  // setDate,
  // endDate,
  loadDateData,
}) => {
  const [dates, setDates] = useState([moment().subtract(1, 'months'), moment()])
  // const [withRetriedUnits,setWithRetriedUnits]=useState(false)

  const setSelectedDate = (date, withRetriedUnits) => {
    setDates([date, date])
    // setWithRetriedUnits(withRetriedUnits)
    loadDateData(date, date, withRetriedUnits)
  }

  const setSelectedDateRagePicker = useCallback(
    (selectedDateRangePicker, withRetriedUnits) => {
      setDates(selectedDateRangePicker)
      loadDateData(
        selectedDateRangePicker[0],
        selectedDateRangePicker[1],
        withRetriedUnits
      )
    },
    [loadDateData]
  )

  return (
    <DatePickerContext.Provider
      value={{
        selectedDate: dates[0],
        setSelectedDate,
        selectedDateRangePicker: dates,
        setSelectedDateRagePicker,
      }}
    >
      {children}
    </DatePickerContext.Provider>
  )
}

export { DatePickerContext }

const mapStateToProps = _ => ({
  //  getState: _ => state,
  // endDate: getEndDate(state),
})
const mapDispatchToProps = dispatch => ({
  // setEndDateDispatch: date => setEndDate(date),
  // dispatch,
  loadDateData: (date, edate, withRetriedUnits) => {
    dispatch((thunk, state) =>
      loadDataForDate(date, edate, withRetriedUnits)(thunk, state)
    )
  },
})

const DatePickerProviderComponnent = connect(
  mapStateToProps,
  mapDispatchToProps
)(DatePickerProvider)
export default DatePickerProviderComponnent
